export enum HelperDrawerSectionEnum {
  GLOBAL = 'global',
  ONBOARDING = 'onboarding',
}
